// extracted by mini-css-extract-plugin
export default {"status":"styles_status__AE0dr","expired":"styles_expired__zc-8C","in_progress":"styles_in_progress__LF6Ao","completed":"styles_completed__cKM9e"};